let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5pPTh")).then(() => parcelRequire('1O92x'));